import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';
import { Input } from '@mm/components';
import './VariableItem.pcss';
import { StoreState } from '@mm/state/store-interfaces';
import PrimarySelect from '@mm/components/legacy-components/PrimarySelect/PrimarySelect';

const VariableItem = props => {
  const { index, variable, onRemove, onVariableUpdate, connectionVariables } =
    props;

  const variables = useSelector(
    (state: StoreState) => state.attribute.entities,
  );
  const [name, setName] = useState(variable.name);
  const [sentAs, setSentAs] = useState(variable.sentAs);
  const [staticValue, setStaticValue] = useState(variable.value);
  const isStatic = variable.static;

  const shouldUpdateVariable = props => updatedVariable => {
    const { isStatic, staticValue, name, sentAs } = props;
    if (isStatic) {
      const isValEq = updatedVariable.value
        ? updatedVariable.value === staticValue
        : !!staticValue;
      const isDiff = !(updatedVariable.sentAs === sentAs && isValEq);
      return staticValue && sentAs && isDiff;
    }

    const isDiff = !(
      updatedVariable.name === name && updatedVariable.sentAs === sentAs
    );
    return name && sentAs && isDiff;
  };

  const onBlur = async () => {
    const variable = connectionVariables[index];

    if (!shouldUpdateVariable(variable)) {
      return;
    }

    const updatedVariable = isStatic
      ? { ...variable, name: sentAs, sentAs, value: staticValue, static: true }
      : { ...variable, name, sentAs, static: false };
    onVariableUpdate(updatedVariable, index);
  };

  const onRemoveLocal = async index => {
    onRemove(index);
  };

  useEffect(() => {
    if (variable.name !== name || variable.sentAs !== sentAs) {
      onBlur();
    }
  }, [name, sentAs]);

  return (
    <div className="webhook-variable__container">
      <div className="webhook-variable__sent-as">
        <Input
          value={sentAs}
          onBlur={onBlur}
          onChange={e => setSentAs(e.target.value)}
          placeholder="Name"
        />
      </div>
      <div className="webhook-variable__name">
        {isStatic ? (
          <Input
            value={staticValue}
            onBlur={onBlur}
            placeholder="Static Value"
            onChange={e => setStaticValue(e.target.value)}
          />
        ) : (
          <PrimarySelect
            className="webhook-variable__attribute"
            dropdownClassName="webhook-variable__attribute-select"
            placeholder="Attribute"
            displayNameKey="friendlyName"
            options={variables}
            value={variables.find(v => v.name === name)}
            onChange={v => {
              setName(v.name);
              setSentAs(v?.friendlyName || v.name);
            }}
            showSearchFilter
            customDropdownStyles={{ zIndex: '1000003' }}
          />
        )}
      </div>
      <DeleteOutlined
        className="webhook-variable__btn"
        onClick={onRemoveLocal}
      />
    </div>
  );
};

export default VariableItem;
